export default __webpack_public_path__ + "static/arindamLehri9-dd7fd9bfb6c222139df19bcc7e65b6d2.jpg";